<template>
    <div class="vue-filter-badge">
        <div class="filter-badge">
            {{ filter.label }}

            <button @click="handleRemove" class="close-button">{{ translations.removeText }}</button>
        </div>
    </div>
</template>

<script>
import translations from "../../mixins/translations";

export default {
    name: "FilterBadge",

    mixins: [translations],

    props: {
        filter: {
            type: Object
        },
        eventBus: {}
    },

    methods: {
        handleRemove() {
            this.eventBus.$emit('remove-filter', this.filter)
        }
    }
}
</script>